<div class="video-modal">
    <iframe class="mfp-iframe" [src]="sanitizer.bypassSecurityTrustResourceUrl(url + '?autoplay=1')" frameBorder="0"  allowFullScreen=""></iframe>
    <button type="button" class="close" (click)="closeModal()" autofocus=false>
        <span><i class="icon-close"></i></span></button>
</div>